module.exports = __webpack_public_path__ + "static/media/burger.71594ec5.png";